class CardReader {
    constructor(videoElement) {
        this.video = videoElement;
        this.video.muted = true;
        this.video.playsinline = true;
        this.video.autoplay = true;

        this.videoWidth = videoElement.offsetWidth;
        this.videoHeight = videoElement.offsetHeight;
        this.canvas = document.createElement('canvas');
        this.stream = null;
        this.video.style.maxHeight = '506.25px';
        window.CurrentCardReader = this;
        this.video.addEventListener('blur', function () {
            console.log('not focused');
            CurrentCardReader.video.play();
        });

        this.video.addEventListener('pause', function () {
            console.log('paused for some reason');
            CurrentCardReader.video.play();
        });
    }

    getImage() {
        let ctx = this.canvas.getContext('2d');
        this.canvas.width = this.video.offsetWidth;
        this.canvas.height = this.video.offsetHeight;
        ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

        return this.canvas.toDataURL('image/jpeg');
    }

    getImageAndContext() {
        let ctx = this.canvas.getContext('2d');
        this.canvas.width = this.video.offsetWidth;
        this.canvas.height = this.video.offsetHeight;
        ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

        return { img: this.canvas.toDataURL('image/jpeg'), ctx: ctx };
    }

    getCropAreaImage(sW, sH) {
        let ctx = this.canvas.getContext('2d');
        this.canvas.width = sW;
        this.canvas.height = sH;
        ctx.drawImage(this.video, (this.video.offsetWidth - sW) / 2, (this.video.offsetHeight - sH) / 2, sW, sH, 0, 0, this.canvas.width, this.canvas.height);

        return this.canvas.toDataURL('image/jpeg');
    }

    dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);
    
        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    
        // write the bytes of the string to a typed array
        let ia = new Uint8Array(byteString.length);
        let i;
        for (i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
    
        return new Blob([ia], {type:mimeString});
    }

    stopStream(){
        if(this.stream == null)
            return;
        
        this.stream.getTracks().forEach(function(track) {
            track.enabled = false;
            });
        
    }

    restartStream(){
        this.stream.getTracks().forEach(function(track) {
            track.enabled = true;
            });
    }

    async startStream(preferBackCamera) {
        
        if(this.stream && this.stream !== null){
            this.restartStream();
            this.video.play();
            return true;
        }

        if (!('mediaDevices' in navigator) && !('getUserMedia' in navigator.mediaDevices)) {
            console.log("no devices found");
            return false;
        }

        let facingMode = 'user';
        if (preferBackCamera)
            facingMode = 'environment';

        let constraints = {
            video: {
                facingMode: facingMode,
                width: { ideal: 900 },
                height: { ideal: 500 } 
            },

            audio: false
        }

        try {
            this.stream = await navigator.mediaDevices.getUserMedia(constraints);
            this.video.srcObject = this.stream;

            let vid = this.video;
            this.video.onloadedmetadata = function(e) {
                vid.play();
            };

            // setTimeout(function () {
            //     this.video.play();
            // }, 200);
          
            return true;
        } catch (err) {
              console.log("no devices found");
            return false;
        }
    }

    getStringTheme (key, defaultValue){
        if(window.AtheneumInstance){
          return window.AtheneumInstance.Theme.getStringProperty(key, defaultValue);
        }else{
          return defaultValue
        }
    }

    getBooleanTheme(key, defaultValue){
        if(window.AtheneumInstance){
            return window.AtheneumInstance.Theme.getBooleanProperty(key, defaultValue);
          }else{
            return defaultValue
          }
    }

    getTranslation(key, defaultValue){
        if(window.AtheneumInstance){
            return window.AtheneumInstance.Translation.get(key, defaultValue);
          }else{
            return defaultValue
          }
    }

    waitFor (delay){
        return new Promise(resolve => setTimeout(resolve, delay));
    }
    
    key(key){
        return atob(key);
    }

    setupProcessing(){
    $('#cameraModal .modal-footer .btn-primary').toggleClass('disabled', true);
       // this.stream.getTracks()[0].enabled = false;
         $('#cameraModal .modal-footer').prepend('<span style="width: calc(100% -15px); text-align: center; display: block; position: absolute; height: 34px; line-height: 34px;" id="cameraModalProcessing">'+this.getTranslation('cameraModalProcessing', 'Processing...')+'</span>');
    }

    endProcessing(){
  $('#cameraModal .modal-footer .btn-primary').toggleClass('disabled', false);
         //    this.stream.getTracks()[0].enabled = true;
               $('#cameraModalProcessing').remove();
    }

    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }

    //providers: "COVVE" | "GEMINI" | "GEMINILITE"
    async getCardDetails(dataURL){
        if(!dataURL)
        {
            //Can't get image so no point repeating as the video isn't set up properly
            throw new Error('image not provided');
        }

        let mode = this.getStringTheme('cardReaderProvider', 'GEMINILITE');
        mode = mode.toUpperCase();
        this.setupProcessing();
       // const regex = /data:.*base64,/;
        
        
        let url = window.AtheneumInstance.API.BASE_URL + '/scan/image';
        let file = this.dataURLtoFile(dataURL, 'bus.jpeg');
     
        const formData  = new FormData();

        formData.append("provider", mode);
        formData.append("file", file);

        if(this.form){
            formData.append("formId", this.form.id);    
        }

        let response = await fetch(url, {
            method: 'POST',
            headers: {
              //'Content-Type': 'application/json',
              'Authorization':  'Bearer ' + window.AtheneumInstance.User.apikey
            },
            body: formData
        });

        if(!response.ok){
            this.endProcessing();
            throw new Error('error in response - '+ response.status + ' - ' + response.statusText);
        }

        try{
          
            let json = await response.json();
            if(json.errorCode !== undefined && json.errorCode != Atheneum.API.ErrorCodes.NO_ERROR){
                let errorCode = json.errorCode;
                let errorCodeHex = undefined;
                if (typeof errorCode == 'number') {
                    errorCodeHex = errorCode.toString(16);
                    while (errorCodeHex.length < 8) {
                        errorCodeHex = '0' + errorCodeHex;
                    }
                }
                let message = window.AtheneumInstance.Translation.getOrGetThemeKey('error' + errorCodeHex, SalesToolkit.Translation.get('badgeScanServerError', 'Ran into an error while scanning badge'));
                if (SalesToolkit.Theme.getBooleanProperty("includeErrorCodeForBadgeScan", true) && (message === SalesToolkit.Translation.get('badgeScanServerError', 'Ran into an error while scanning badge'))) {
                    message += " - " + errorCode;
                }
                throw new Error(message);
            }
          
            this.endProcessing();
            return json;

        }catch(err){
          this.endProcessing();
            console.log(err.toString());
            throw new Error(err.toString());
        }
       
    }

    makeRequest(url,data, ak) {
        let aThis = this;
        return new Promise(function (resolve, reject) {

            $.ajax({
                url: url,
                headers: { "Authorization": this.key(ak) },
                method: 'POST',
                data: data,
                cache: false,
                contentType: false, //required for multipart
                processData: false  //required for multipart
            }).done(function (data) {
                resolve(data);
            }).fail(function (jqXHR, textStatus) {
                reject(jqXHR, textStatus);
            });

        });
    
    }

}